import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../Store/AuthContext";

export default function AboutSectionHome() {
  const { webSetting } = useAuth();
  return (
    <>
      <section className="about-section fix section-bg section-padding">
        <div className="right-shape">
          <img src="assets/img/home-1/about/right-shape.png" alt="img" />
        </div>
        <div className="container">
          <div className="about-wrapper">
            <div className="row g-4">
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                <div className="about-image">
                  {webSetting.Aboutimg !== "" ? (
                    <img src={webSetting.Aboutimg} alt="" />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-content">
                  <div className="section-title mb-0">
                    <h2 className="wow fadeInUp mb-3 aboutSectiontitle">
                      {/* <i
                        className="fa fa-angle-double-left"
                        aria-hidden="true"
                      ></i> */}
                      {webSetting?.abouttitle || ""}
                      {/* <i
                        className="fa fa-angle-double-right"
                        aria-hidden="true"
                      ></i> */}
                    </h2>
                    <h3 className="wow fadeInUp mb-3" data-wow-delay=".3s">
                      {webSetting?.aboutSubtitle || ""}
                    </h3>
                    <h3 className="wow fadeInUp text-dark" data-wow-delay=".3s">
                      "{webSetting?.aboutTagline || ""}"
                    </h3>
                  </div>
                  <p
                    className="about-text wow fadeInUp mb-2"
                    data-wow-delay=".5s"
                  >
                    {webSetting?.aboutdec || ""}
                  </p>
                  <div
                    className="about-list-item wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div className="list-item">
                      <ul className="list">
                        <li>
                          <i className="fa-solid fa-arrow-right"></i>
                          Quality real estate services
                        </li>
                        <li>
                          <i className="fa-solid fa-arrow-right"></i>
                          100% Satisfaction guarantee
                        </li>
                        <li>
                          <i className="fa-solid fa-arrow-right"></i>
                          Highly professional team
                        </li>
                        <li>
                          <i className="fa-solid fa-arrow-right"></i>
                          Dealing always on time
                        </li>
                      </ul>
                      <Link
                        to="https://bhadorva.com/about-us"
                        className="theme-btn mt-3"
                      >
                        Read MORE
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
